<template>
    <div class="page">
        <h1>Shrimp Suggester</h1>
        <span class="sub-heading">By <a href="https://www.shrimpscience.com/">Shrimp Science</a></span>

        <img :src="shrimpImageUri" alt="Red cherry shrimp illustration" class="with-bottom-margin">

        <p>This tool will help you find the best shrimp for your tank's parameters, identify which shrimp can live together, and suggest optimal parameters for those shrimp.</p>

        <router-link to="/tank-parameters" class="button primary">Start</router-link>
    </div>
</template>

<script>
export default {
    name: 'IntroPage',
    computed: {
        shrimpImageUri() {
            return process.env.BASE_URL + 'images/large_shrimp.png'
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/size";
@import "@/assets/scss/mixins";

.page {
    padding: 1em;

    img {
        object-fit: contain;
        max-width: 100%;
    }

    .button.primary {
        display: inline-block;
        margin-top: 3em;
        width: 100%;

        @include breakpoint(tablet) {
            width: 50%;
        }
    }
}

h1 {
    font-size: 3em;
    margin-bottom: 0;
}

span.sub-heading {
    display: block;
    margin-bottom: 3em;
}
</style>